import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";

import Home from "@/pages/Home";
import Reembolso from "@/pages/Reembolso";
import Contactos from "@/pages/Contactos";
import AdminLogin from "@/pages/AdminLogin";
import AdminReembolsos from "@/pages/AdminReembolsos";
import AdminReembolsoDetail from "@/pages/AdminReembolsoDetail";
import AdminContactos from "@/pages/AdminContactos";
import AdminEncomendas from "@/pages/AdminEncomendas";
import AdminEncomendaDetail from "@/pages/AdminEncomendaDetail";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              style: { fontFamily: "Manrope, sans-serif" },
            }}
          />
          <Routes>
            {/* Public routes */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/reembolso" element={<Reembolso />} />
              <Route path="/contactos" element={<Contactos />} />
            </Route>

            {/* Compatibility redirect for previously-published URL */}
            <Route path="/pages/reembolsos" element={<Navigate to="/reembolso" replace />} />

            {/* Admin login (public) */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Admin protected */}
            <Route
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/admin" element={<Navigate to="/admin/reembolsos" replace />} />
              <Route path="/admin/reembolsos" element={<AdminReembolsos />} />
              <Route path="/admin/reembolsos/:numero" element={<AdminReembolsoDetail />} />
              <Route path="/admin/encomendas" element={<AdminEncomendas />} />
              <Route path="/admin/encomendas/:name" element={<AdminEncomendaDetail />} />
              <Route path="/admin/contactos" element={<AdminContactos />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
